/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderMonthAggregateDto
 */
export interface OrderMonthAggregateDto {
    /**
     * 
     * @type {number}
     * @memberof OrderMonthAggregateDto
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMonthAggregateDto
     */
    month: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMonthAggregateDto
     */
    orderCount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderMonthAggregateDto
     */
    orderAmount: number;
}

/**
 * Check if a given object implements the OrderMonthAggregateDto interface.
 */
export function instanceOfOrderMonthAggregateDto(value: object): value is OrderMonthAggregateDto {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('orderCount' in value) || value['orderCount'] === undefined) return false;
    if (!('orderAmount' in value) || value['orderAmount'] === undefined) return false;
    return true;
}

export function OrderMonthAggregateDtoFromJSON(json: any): OrderMonthAggregateDto {
    return OrderMonthAggregateDtoFromJSONTyped(json, false);
}

export function OrderMonthAggregateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderMonthAggregateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'month': json['month'],
        'orderCount': json['orderCount'],
        'orderAmount': json['orderAmount'],
    };
}

export function OrderMonthAggregateDtoToJSON(json: any): OrderMonthAggregateDto {
    return OrderMonthAggregateDtoToJSONTyped(json, false);
}

export function OrderMonthAggregateDtoToJSONTyped(value?: OrderMonthAggregateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'month': value['month'],
        'orderCount': value['orderCount'],
        'orderAmount': value['orderAmount'],
    };
}

